import { Component, OnDestroy, OnInit } from '@angular/core';
import { ClearIconSharedService } from './clearIcon.sharedService';

@Component({
  selector: 'axis-clear-input',
  templateUrl: './clear.component.html',
  host: {
    class: 'axis-input-clear'
  }
})
export class ClearComponent implements OnInit, OnDestroy {
  // @HostBinding('class.axis-input-clear') axisInputClear = true;
  public clearInputInstance: any;
  public uniqueKey: number;
  public isdisabled = false;

  constructor(private clearIconSharedService: ClearIconSharedService) {}

  ngOnInit() {
    this.clearInputInstance = this.clearIconSharedService.getInstance(
      this.uniqueKey
    );
  }

  clearInputValue() {
    if (this.clearInputInstance) {
      this.clearInputInstance.onTouchedEvent.emit();
      this.clearInputInstance.compRefClicked = true;
    }
    this.clearInputInstance.clearInputValue();
    this.destroyInstance();
  }

  ngOnDestroy() {
    this.destroyInstance();
  }

  destroyInstance() {
    this.clearInputInstance = null;
    this.clearIconSharedService.destroyInstance(this.uniqueKey);
  }
}
